import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sortino-ratio-calculator',
  component: () => import('../../routes/SortinoRatioCalculator.svelte'),
  card: {
    id: 'sortino-ratio',
    title: 'Sortino Ratio',
    description: 'Measure risk-adjusted returns focusing only on downside volatility — more precise than the Sharpe Ratio.',
    icon: 'trending_down',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/sortino-ratio-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Sortino Ratio Calculator – Risk-Adjusted Return with Downside Deviation',
    description: 'Free Sortino Ratio calculator measures investment performance using downside volatility. More accurate than Sharpe Ratio for evaluating risk-adjusted returns.',
  },
};

export default meta;
